<div class="right">
  <div class="avatar-xs me-3" align="center">
            <span class="avatar-title rounded-circle bg-success ">
              <i class="fas {{getImageBy(generalQuantity)}}"></i>
            </span>
  </div>
  <h4><b>{{generalQuantity.quantity}}</b><i class="mdi mdi-chevron-up ms-1 text-success"></i></h4>
  <p> {{generalQuantity.service | translate}} </p>
</div>
